<ul class="layout-menu">
    <li doctor-app-menuitem *ngFor="let item of model; 
            let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>